// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export {
	tableCellBackgroundColor,
	tableHeaderCellBackgroundColor,
	tableToolbarColor,
	tableTextColor,
	tableBorderColor,
	tableFloatingControlsColor,
	tableCellSelectedColor,
	tableToolbarSelectedColor,
	tableBorderSelectedColor,
	tableCellSelectedDeleteIconColor,
	tableCellSelectedDeleteIconBackground,
	tableCellDeleteColor,
	tableBorderDeleteColor,
	tableToolbarDeleteColor,
	tableCellHoverDeleteIconColor,
	tableCellHoverDeleteIconBackground,
	tableBorderRadiusSize,
	tablePadding,
	tableScrollbarOffset,
	tableMarginFullWidthMode,
	tableInsertColumnButtonSize,
	tableDeleteButtonSize,
	tableDeleteButtonOffset,
	tableToolbarSize,
	tableControlsSpacing,
	tableInsertColumnButtonOffset,
	layoutButtonSize,
	lineMarkerOffsetFromColumnControls,
	lineMarkerSize,
	columnControlsDecorationHeight,
	columnControlsZIndex,
	columnControlsSelectedZIndex,
	rowControlsZIndex,
	columnResizeHandleZIndex,
	insertLineWidth,
	resizeHandlerAreaWidth,
	resizeLineWidth,
	resizeHandlerZIndex,
	contextualMenuTriggerSize,
	contextualMenuDropdownWidth,
	contextualMenuDropdownWidthDnD,
	stickyRowZIndex,
	stickyRowOffsetTop,
	stickyHeaderBorderBottomWidth,
	tableOverflowShadowWidth,
	tableOverflowShadowWidthWide,
	tablePopupMenuFitHeight,
	dropTargetsZIndex,
	TABLE_SNAP_GAP,
	TABLE_HIGHLIGHT_GAP,
	TABLE_HIGHLIGHT_TOLERANCE,
	STICKY_HEADER_TOGGLE_TOLERANCE_MS,
	TABLE_GUIDELINE_VISIBLE_ADJUSTMENT,
	TABLE_DRAG_MENU_SORT_GROUP_HEIGHT,
	TABLE_DRAG_MENU_PADDING_TOP,
	TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT,
	dragMenuDropdownWidth,
	dragTableInsertColumnButtonSize,
	dropTargetExtendedWidth,
	colorPalletteColumns,
	tableResizerWidth,
} from '@atlaskit/editor-plugin-table/ui/consts';
